import Feature18 from './Feature18'
export default Feature18
